// extracted by mini-css-extract-plugin
export default {"spinner":"peacegame_Spinner_spinner","centered":"peacegame_Spinner_centered"};